import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { FilterCriteria } from '@woolworthsnz/trader-api';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SearchMediatorService {
	[key: string]: any;
	private _filterSelectionEvent = new Subject<FilterCriteria[]>();
	private _loadMoreEvent = new Subject<boolean>();
	private _pageSizeChangeEvent = new Subject<number>();
	private _pageChangeEvent = new Subject<number>();
	private _removeFilterEvent = new Subject<FilterCriteria>();
	private _removeAllFiltersEvent = new Subject<boolean>();
	private _sortChangeEvent = new Subject<string>();
	private _scrollToTopEvent = new Subject<boolean>();
	private _inStockProductsOnlyToggleEvent = new Subject<boolean>();

	get filterSelection$(): Observable<FilterCriteria[]> {
		return this._filterSelectionEvent.asObservable();
	}

	get loadMore$(): Observable<boolean> {
		return this._loadMoreEvent.asObservable();
	}

	get pageSizeChange$(): Observable<number> {
		return this._pageSizeChangeEvent.asObservable();
	}

	get pageChange$(): Observable<number> {
		return this._pageChangeEvent.asObservable();
	}

	get removeFilter$(): Observable<FilterCriteria> {
		return this._removeFilterEvent.asObservable();
	}

	get removeAllFilters$(): Observable<boolean> {
		return this._removeAllFiltersEvent.asObservable();
	}

	get sortChange$(): Observable<string> {
		return this._sortChangeEvent.asObservable();
	}

	get scrollToTop$(): Observable<boolean> {
		return this._scrollToTopEvent.asObservable();
	}

	get inStockProductsOnlyToggle$(): Observable<boolean> {
		return this._inStockProductsOnlyToggleEvent.asObservable();
	}

	emitFilterSelectEvent(filters: FilterCriteria[]): void {
		this._filterSelectionEvent.next(filters);
	}

	emitPageSizeChangeEvent(size: number): void {
		this._pageSizeChangeEvent.next(size);
	}

	emitPageChangeEvent(size: number): void {
		this._pageChangeEvent.next(size);
	}

	emitSortChangeEvent(sortOption: string): void {
		this._sortChangeEvent.next(sortOption);
	}

	emitLoadMoreEvent(): void {
		this._loadMoreEvent.next(true);
	}

	emitScrollToTopEvent(): void {
		this._scrollToTopEvent.next(true);
	}

	emitRemoveFilterEvent(filter: FilterCriteria): void {
		this._removeFilterEvent.next(filter);
	}

	emitRemoveAllFiltersEvent(): void {
		this._removeAllFiltersEvent.next(true);
	}

	emitInStockProductsOnlyToggleEvent(toggleState: boolean): void {
		this._inStockProductsOnlyToggleEvent.next(toggleState);
	}
}
